import { StaffingAssignmentListMember } from 'domain/shared/staffing';
import { Modal } from 'framework/ui/ui-builder';
import { DateInput, FormFieldsData, ModalForm, NumberInput } from 'framework/form';
import { Box } from '@mui/material';

import { useAssignmentService } from 'domain/shared/assignment';

interface ConfirmVirtualAssignmentModalProps {
  assignment: StaffingAssignmentListMember;
  isOpen: boolean;
  onClose: () => void;
  onConfirmed: () => Promise<void>;
  projectStartDate?: string;
}

interface ConfirmVirtualAssignmentFormFields {
  fromDate: string;
  toDate: string;
  minPercent: number;
  maxPercent: number;
}

const ConfirmVirtualAssignmentModal = ({
  assignment,
  isOpen,
  onClose,
  onConfirmed,
  projectStartDate,
}: ConfirmVirtualAssignmentModalProps) => {
  const { confirmVirtual, getConfirmAssignmentValidationSchema } = useAssignmentService();

  const handleSubmit = async (values: FormFieldsData) => {
    const formValues = values as FormFieldsData<ConfirmVirtualAssignmentFormFields>;

    const payload = {
      id: Number(assignment.assignmentId),
      fromDate: formValues.fromDate,
      toDate: formValues.toDate,
      minPercent: Number(formValues.minPercent),
      maxPercent: Number(formValues.maxPercent),
    };

    return confirmVirtual(assignment.assignmentId, payload);
  };

  return (
    <Modal isOpen={isOpen} onToggle={onClose} title="Confirm virtual assignment">
      <ModalForm
        modalOpen={isOpen}
        closeModal={onClose}
        submitFormFunc={handleSubmit}
        getValidationSchemaFunc={() => getConfirmAssignmentValidationSchema(projectStartDate)}
        initialData={{
          fromDate: assignment.from,
          toDate: assignment.to,
          minPercent: assignment.minPercent,
          maxPercent: assignment.maxPercent,
        }}
        afterSubmit={{
          execute: onConfirmed,
          message: 'Virtual assignment has been successfully confirmed.',
        }}
        submitButtonText="Submit"
      >
        <Box display="grid" gridTemplateColumns={{ xs: '1fr', md: '1fr 1fr' }} gap={2}>
          <Box>
            <DateInput source="fromDate" label="From" minDate={projectStartDate} />
          </Box>
          <Box>
            <DateInput source="toDate" label="To" />
          </Box>
          <Box>
            <NumberInput
              source="minPercent"
              label="Min percent"
              integerOnly
              slotProps={{
                htmlInput: {
                  min: 0,
                  step: 25,
                },
              }}
            />
          </Box>
          <Box>
            <NumberInput
              source="maxPercent"
              label="Max percent"
              integerOnly
              slotProps={{
                htmlInput: {
                  min: 0,
                  step: 25,
                },
              }}
            />
          </Box>
        </Box>
      </ModalForm>
    </Modal>
  );
};

export default ConfirmVirtualAssignmentModal;
